export default __webpack_public_path__ + "static/Konditor Seite 2-0d9856ecf646e70c25bb72fabb56e4fb.jpg";